<template lang="pug">
feathers-vuex-find(service="toluna" :query="{}" watch="query")
    v-card(slot-scope="{ items, isFindPending }")
        //- v-card-title Toluna Questionnaire Lists
        //-     v-spacer
        v-toolbar(flat dense)
            v-tabs(v-model="tab")
                v-tab Toluna Questionnaire Lists
                v-tab Questionnaire Templates

        v-tabs-items(v-model="tab")
            v-tab-item
                v-card-title Existing Questionnaire from Toluna
                    v-spacer
                v-data-table(
                    :headers="headers"
                    :loading="isFindPending"
                    loading-text="Fetching Data..."
                    :items="getItems(items)"
                    single-expand
                    show-expand
                )
                    template(v-slot:item.actions="{ item }")
                        b {{ item.TranslatedQuestion.DisplayNameTranslation }}

                    template(v-slot:expanded-item="{ headers, item }")
                        td(:colspan="headers.length")
                            v-row
                                v-col(align="end") 
                                    add-to-template(:id="item.id" :defaultAnswer="getDefaultAnswer(item)")
                                //- | {{ item.AnswerType }}
                                //- | {{ item.TranslatedAnswers }}
                                //- quest-lists-table(:key="item.id" :type="item.type" :routin="item.routin")

            template-lists(:items="getItems(items)")
            


</template>

<script>
import AddToTemplate from './components/AddToTemplate.vue';
import TemplateLists from './components/TemplateLists.vue';

export default {
    data() {
        return {
            tab: null,
            idLists: {},
            headers: [
                {
                    text: 'Questions',
                    align: 'start',
                    sortable: false,
                    value: 'actions',
                },
                {
                    text: '',
                    align: 'end',
                    value: 'data-table-expand'
                }
            ],
            tempalteHeaders: [
                {
                    text: 'Template Name',
                    align: 'start',
                    sortable: false,
                    value: 'template-name',
                },
                {
                    text: '',
                    align: 'end',
                    value: 'data-table-expand'
                }
            ]
        }
    },
    methods: {
    //     ...mapActions('api/toluna', { tolunaQuestionaire: 'find' })
        getItems(items) {
            const ids = {};
            const result = (items.length !== 0 ? items[0].data : []).map((item) => {
                item.id = item.TranslatedQuestion.QuestionID;
                return item;
            }).filter((item) => (item.TranslatedQuestion.CultureID === 1 || item.TranslatedQuestion.CultureID === 5) && !!item.TranslatedAnswers)
            .reduce((ret, item) => {
                if(!ids[item.id]) {
                    ids[item.id] = item;
                    ret.push(item);
                }
                return ret;
            }, []);
            this.idLists = ids;
            return result;
        },
        getDefaultAnswer(item) {
            return item.TranslatedAnswers[0].AnswerID;
        }
    },
    components: {
        AddToTemplate,
        TemplateLists
    }
}
</script>